import { Dialog } from 'primereact/dialog';
import React, { useEffect, useState } from 'react';
import { MenuItem } from 'primereact/menuitem';
import { createNewSessionOperations } from './operations/create-new-session-operations';
import globalCourseStore from '../../../../../../stores/global-course-store';
import globalProgramStore from '../../../../../../stores/program-store';
import { SelectedSlotsState } from '../../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../../../../calendar/tabs/serial/create-lecture-serial-tab';
import { addExamClassesOperations } from './operations/add-exam-classes-operations';
import { getExamDetailsOperation } from './operations/get-exam-details-operation';
import './exam-page.css';

import {
  ClassSchedule,
  ExamMetadata,
  ExamSessionDetails,
} from '../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { SideBarSessions } from './side-bar-sessions/side-bar-sessions';
import { ExamPageAll } from './tabs/exam-page-all';
import { ExamPageStudentRegistrations } from './tabs/student-registration/exam-page-student-registrations';
import { ExamPageClassScheduleTab } from './tabs/class-schedules/exam-page-class-schedule-tab';
import { ExamPageProtectorsTab } from './tabs/protectors-scheduling/exam-page-protectors-tab';
import { ExamPageStudentsScheduling } from './tabs/student-scheduling/exam-page-students-scheduling';
import { ExamPageAttendanceTab } from './tabs/attendance/exam-page-attendance-tab';
import { ExamPageGradesTab } from './tabs/grades/exam-page-grades-tab';

import { TabBarWithIcons } from '../../../../../../component/tab-bar/tab-bar-with-icons';

import './exam-page.css';
import ClassIcon from '../../../../../../assets/icons/exam/class.svg';
import ClassBlueIcon from '../../../../../../assets/icons/exam/class-blue.svg';

import studentRegistrationIconHover from '../../../../../../assets/icons/exam/student-registration-blue.svg';
import studentRegistrationIcon from '../../../../../../assets/icons/exam/student-registration.svg';

import studentSchedulingIcon from '../../../../../../assets/icons/exam/student-scheduling.svg';
import studentSchedulingIconHover from '../../../../../../assets/icons/exam/student-scheduling-blue.svg';

import protector from '../../../../../../assets/icons/exam/protector.svg';
import protectorHover from '../../../../../../assets/icons/exam/protector-hover.svg';

import attendance from '../../../../../../assets/icons/exam/attendance.svg';
import attendanceHover from '../../../../../../assets/icons/exam/attendance-blue.svg';

import doc from '../../../../../../assets/icons/exam/doc.svg';
import docHover from '../../../../../../assets/icons/exam/doc-blue.svg';

import grade from '../../../../../../assets/icons/exam/grades.svg';
import gradeHover from '../../../../../../assets/icons/exam/grades-blue.svg';
import { SessionHeader } from './session-header/session-header';
import { ExaminationQuestionnaire } from './tabs/examination-questionnaire/examination-questionnaire';
import { Checkbox } from 'primereact/checkbox';
import { ExamSessionBottomStepper } from './componenets/bottom-stepper/exam-session-bottom-stepper';
import { Tooltip } from 'primereact/tooltip';

export interface ExamDetailsPageDatamodel {
  examDetails: ExamMetadata;
  onHide: () => any;
}

export const ExamDetailsPage: React.FC<ExamDetailsPageDatamodel> = ({
  examDetails,
  onHide,
}) => {
  const [sessionsDetails, setSessionDetailsData] = useState<
    ExamSessionDetails[]
  >([]);

  const setSessionDetails = (sessionsDetails: ExamSessionDetails[]) => {
    const sortedSessions = [...sessionsDetails].sort((a, b) => a.id - b.id);

    setSessionDetailsData(sortedSessions);
  };

  const items2 = [
    {
      text: 'רישום תלמידים',
      image: studentRegistrationIcon,
      imageHover: studentRegistrationIconHover,
    },
    {
      text: 'שיבוץ לכיתות',
      image: ClassIcon,
      imageHover: ClassBlueIcon,
    },

    {
      text: 'שיבוץ סטודנטים',
      image: studentSchedulingIcon,
      imageHover: studentSchedulingIconHover,
    },

    {
      text: 'שיבוץ משגיחים',
      image: protector,
      imageHover: protectorHover,
    },
    {
      text: 'שאלון',
      image: doc,
      imageHover: docHover,
    },
    {
      text: 'נוכחות',
      image: attendance,
      imageHover: attendanceHover,
    },
    {
      text: 'ציונים',
      image: grade,
      imageHover: gradeHover,
    },
  ];

  useEffect(() => {
    const programId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    const fetchExamDetails = async () =>
      await getExamDetailsOperation(
        programId,
        currentCourseId,
        examDetails.id,
        setSessionDetails,
      );
    fetchExamDetails();
  }, [examDetails]);

  const [selectedSessionIndex, setSelectedSessionIndex] = useState(0);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const items: MenuItem[] = [
    {
      label: 'המבחן נוצר',
      template: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: '32px',
              width: '32px',
              border: '1px solid #f3f4f6',
              borderRadius: '50%',
              color: '#4b5563',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            1
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
              marginTop: '16px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Checkbox checked={true} />
              <label>יצירת מועד</label>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Checkbox checked={true} />
              <label>יצירת מועד</label>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Checkbox checked={true} />
              <label>יצירת מועד</label>
            </div>
          </div>
        </div>
      ),
    },
    {
      label: 'שיבוץ לכיתות',
      template: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: '32px',
              width: '32px',
              border: '1px solid #f3f4f6',
              borderRadius: '50%',
              color: '#4b5563',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            2
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
              marginTop: '16px',
            }}
          >
            <label>asd</label>
          </div>
        </div>
      ),
    },
    {
      label: 'שיבוץ משגיחים',
    },

    {
      label: 'ממתין לבחינה',
    },

    {
      label: 'הבחינה התחילה (טרם הסתיים)',
    },

    {
      label: 'הבחינה התבצעה',
    },
    {
      label: 'מחברות נאספו לבדיקה',
    },

    {
      label: 'הוזנו ציונים',
    },
  ];

  const [selectedSessionId, setSelectedSessionId] = useState<number | null>(
    null,
  );

  useEffect(() => {
    console.log('State updated - selectedSessionId is now:', selectedSessionId);
  }, [selectedSessionId]);

  const currentCourse = globalCourseStore.getCurrentCourse();

  const currentProgramId = globalProgramStore.getCurrentId();

  const [addSessionLoading, setAddSessionLoading] = useState(false);

  const handleCreateNewSession = async () => {
    await createNewSessionOperations(
      currentProgramId,
      currentCourse?.metadata.id,
      examDetails.id,
      setAddSessionLoading,
      setSessionDetails,
    );
  };

  const [addSchedule, setAddSchedule] = useState(false);

  const onApprove = async (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide: () => any,
  ) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourse = globalCourseStore.getCurrentCourse();
    const examSessionId = sessionsDetails[selectedSessionIndex].id;

    await addExamClassesOperations(
      currentProgramId,
      currentCourse?.metadata.id,
      examDetails.id,
      examSessionId,
      selectedSlotsState,
      lecturesIdsWithActivityTypeId,
      setIsLoadingCreateLectures,
      setSessionDetails,
      onHide,
    );
  };

  const [classSchedule, setClassSchedule] = useState<ClassSchedule | null>(
    null,
  );

  const tabs = [
    <ExamPageStudentRegistrations
      examId={examDetails.id}
      examSession={sessionsDetails[selectedSessionIndex]}
      setSessionDetails={setSessionDetails}
    />,
    <ExamPageClassScheduleTab
      examId={examDetails.id}
      examSession={sessionsDetails[selectedSessionIndex]}
      classesSchedule={sessionsDetails[selectedSessionIndex]?.classesSchedule}
      onApprove={onApprove}
      setSessionDetails={setSessionDetails}
    />,
    <ExamPageStudentsScheduling
      examId={examDetails.id}
      examSession={sessionsDetails[selectedSessionIndex]}
      setSessionDetails={setSessionDetails}
    />,
    <ExamPageProtectorsTab
      sessionId={sessionsDetails[selectedSessionIndex]?.id}
      setSessionDetails={setSessionDetails}
      examId={examDetails.id}
      classesSchedule={sessionsDetails[selectedSessionIndex]?.classesSchedule}
    />,
    <ExaminationQuestionnaire
      examId={examDetails.id}
      examSession={sessionsDetails[selectedSessionIndex]}
      setSessionDetails={setSessionDetails}
    />,
    <ExamPageAttendanceTab
      examId={examDetails.id}
      examSession={sessionsDetails[selectedSessionIndex]}
      setSessionDetails={setSessionDetails}
    />,
    <ExamPageGradesTab
      examId={examDetails.id}
      examSession={sessionsDetails[selectedSessionIndex]}
      setSessionDetails={setSessionDetails}
    />,
    <ExamPageAll
      sessionsDetails={sessionsDetails}
      selectedSessionIndex={selectedSessionIndex}
      classSchedule={classSchedule}
      onApprove={onApprove}
      setSessionDetails={setSessionDetails}
      setClassSchedule={setClassSchedule}
      addSchedule={addSchedule}
      setAddSchedule={setAddSchedule}
      examDetails={examDetails}
    />,
  ];

  const currentSession = sessionsDetails[selectedSessionIndex];
  const isClassedScheduled = currentSession?.classesSchedule.length > 0;
  const isProtectorsScheduled = !currentSession?.classesSchedule.some(
    (item) => item.protectors.length === 0,
  );

  const trueEnrollmentCount = currentSession?.studentsRegistrations.reduce(
    (count, student) => {
      return student.enrollment === true ? count + 1 : count;
    },
    0,
  );

  const trueClassRegistration = currentSession?.classesSchedule.reduce(
    (count, classSchedule) => {
      return count + classSchedule.enrollment.length;
    },
    0,
  );

  const isStudentRegister =
    trueEnrollmentCount === trueClassRegistration && trueEnrollmentCount > 0;

  console.log('XXXXXXXXX');

  return (
    <Dialog
      /*header={() => <div style={{ paddingRight: '200px' }}>asdasdasd</div>}*/
      visible={false || true}
      showHeader={false}
      focusOnShow={false}
      style={{
        height: '90vh',
        width: '99vw',
        backgroundColor: 'white',
        padding: '0px',
      }}
      contentClassName="dialog-no-padding"
      pt={{
        content: {
          className: 'dialog-no-padding',

          style: {
            padding: '0px',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          },
        }, // Remove content padding
      }}
      onHide={onHide}
      /*footer={() => (
        <div>
          <Steps style={{ direction: 'ltr' }} model={items} activeIndex={2} />
        </div>
      )}*/
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
        }}
      >
        <i
          className="pi pi-times close-icon-tooltip"
          onClick={onHide}
          data-pr-tooltip="לחץ לסגירה" // <-- This is the tooltip text
          style={{
            position: 'absolute',
            top: '16px',
            left: '16px',
            fontSize: '1.5rem',
            cursor: 'pointer',
            zIndex: 1000,
            color: '#666',
          }}
        />
        <Tooltip target=".close-icon-tooltip" />

        <SideBarSessions
          sessions={sessionsDetails}
          setSessionIndex={setSelectedSessionIndex}
          selectedIndex={selectedSessionIndex}
          handleCreateNewSession={handleCreateNewSession}
          createNewSessionLoading={addSessionLoading}
          examId={examDetails.id}
          setSessionDetails={setSessionDetails}
        />
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            justifyContent: 'space-between',
          }}
        >
          <div>
            <div style={{ paddingLeft: '32px', backgroundColor: '#f9fafb' }}>
              <SessionHeader
                examId={examDetails.id}
                sessionNumber={selectedSessionIndex}
                examSessionDetails={sessionsDetails[selectedSessionIndex]}
                setSessionDetails={setSessionDetails}
              />
            </div>

            <TabBarWithIcons
              tabs={items2}
              onClick={(index) => setSelectedTabIndex(index)}
            />
            <div style={{ marginTop: '16px' }}>{tabs[selectedTabIndex]}</div>
          </div>

          <ExamSessionBottomStepper
            examId={examDetails.id}
            examSession={sessionsDetails[selectedSessionIndex]}
            setSessionDetails={setSessionDetails}
          />
        </div>
      </div>
    </Dialog>
  );
};
